import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background: #000;
  color: #fff;
`;

export const FooterWrap = styled.div`
  padding: 32px 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

export const FooterCol = styled.div`
  flex: 1;
  min-width: 220px;
  padding: 0 10px;
`;

export const FooterLinkTitle = styled.h1`
  font-size: 14px;
  margin-bottom: 12px;
  text-transform: uppercase;
`;

export const FooterLink = styled(RouterLink)`
  display: block;
  color: #fff;
  text-decoration: none;
  margin-bottom: 6px;
  font-size: 14px;

  &:hover {
    color: #01bf71;
    transition: 0.3s ease-out;
  }
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin: 10px auto;
  font-size: 13px;
  text-align: center;
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 16px;
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 22px;

  &:hover {
    color: #01bf71;
  }
`;

export const LogoImage = styled.img`
  height: 70px;
  max-width: 180px;
  margin-top: 12px;

  @media screen and (max-width: 480px) {
    height: 50px;
  }
`;
